import { useEffect } from 'react';

import { titleCaseFirstLetter } from 'Utilities';
import metatitle from 'Utilities/metatitle';

type MetaTagsData = {
  description?: string;
  title?: string;
};

export const useMetaTags = (metaData: MetaTagsData, path?: string) => {
  useEffect(() => {
    if (!metaData.title && !metaData.description) {
      return;
    }

    if (metaData.title) {
      metatitle.formatTitle(path || globalThis?.location.pathname, titleCaseFirstLetter(metaData.title));
    }

    if (metaData.description) {
      metatitle.formatDescription(titleCaseFirstLetter(metaData?.description ?? ''));
    }
  }, [metaData.title, metaData.description, path]);
};
